import {CachedTransform} from "js-vextensions";
import {Activity} from "./activities/@Activity";
import {GetDoc, CreateAccessor, GetDocs} from "mobx-graphlink";

export function GetActivity(id: string|n): Activity|n {
	return GetDoc({}, a=>a.activities.get(id!));
}
export const GetActivities = CreateAccessor((userID: string|n): Activity[]=>{
	return GetDocs({
		params: {filter: {creator: userID != null && {equalTo: userID}}},
	}, a=>a.activities);
});